import { Children, Component, cloneElement, createElement } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

var TableVerticalScrollbar = /** @class */ (function (_super) {
    __extends(TableVerticalScrollbar, _super);
    function TableVerticalScrollbar(props) {
        var _this = _super.call(this, props) || this;
        _this.minHeight = 15;
        _this.onMouseDown = function (event) {
            event.preventDefault();
            _this.setState({
                isMoving: true,
                previousMoveClientY: event.clientY
            });
        };
        _this.onMouseMove = function (event) {
            event.preventDefault();
            /* tslint:disable:prefer-const */
            var _a = _this.state, percentageScrolled = _a.percentageScrolled, containerHeight = _a.containerHeight, theadHeight = _a.theadHeight, scrollbarHeight = _a.scrollbarHeight, isMoving = _a.isMoving, previousMoveClientY = _a.previousMoveClientY;
            /* tslint:enable:prefer-const */
            if (!isMoving) {
                return;
            }
            var currentMoveClientY = event.clientY;
            var deltaY = currentMoveClientY - previousMoveClientY;
            var scrollbarMoveableDistance = containerHeight - theadHeight - scrollbarHeight;
            percentageScrolled = scrollbarMoveableDistance
                ? (scrollbarMoveableDistance * percentageScrolled + deltaY) /
                    scrollbarMoveableDistance
                : 0;
            percentageScrolled = Math.max(0, Math.min(percentageScrolled, 1));
            previousMoveClientY = currentMoveClientY;
            _this.props.onScroll(percentageScrolled);
            _this.setState({
                percentageScrolled: percentageScrolled,
                previousMoveClientY: previousMoveClientY
            });
        };
        _this.onMouseUp = function (event) {
            event.preventDefault();
            _this.setState({
                isMoving: false,
                previousMoveClientY: 0
            });
        };
        _this.onMouseOver = function () {
            _this.setState({ focused: true });
        };
        _this.onMouseOut = function () {
            _this.setState({ focused: false });
        };
        _this.state = {
            focused: false,
            containerHeight: 0,
            tableHeight: 0,
            theadHeight: 0,
            scrollbarHeight: 0,
            percentageScrolled: props.scrollTo,
            isMoving: false,
            previousMoveClientY: 0
        };
        return _this;
    }
    TableVerticalScrollbar.prototype.componentDidMount = function () {
        this.calculateDimensions();
        this.scrollbar.addEventListener("mousedown", this.onMouseDown);
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", this.onMouseUp);
    };
    TableVerticalScrollbar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.state.percentageScrolled !== nextProps.scrollTo) {
            this.setState({ percentageScrolled: nextProps.scrollTo });
        }
    };
    TableVerticalScrollbar.prototype.componentDidUpdate = function () {
        var _a = this.props, container = _a.container, table = _a.table;
        var _b = this.state, containerHeight = _b.containerHeight, tableHeight = _b.tableHeight;
        var newContainerHeight = container.getBoundingClientRect().height;
        var newTableHeight = table.getBoundingClientRect().height;
        if (containerHeight !== newContainerHeight ||
            tableHeight !== newTableHeight) {
            this.calculateDimensions();
        }
    };
    TableVerticalScrollbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, customStyle = _a.customStyle, table = _a.table;
        var _b = this.state, focused = _b.focused, percentageScrolled = _b.percentageScrolled, containerHeight = _b.containerHeight, tableHeight = _b.tableHeight, theadHeight = _b.theadHeight, scrollbarHeight = _b.scrollbarHeight;
        var isScrollable = table
            ? containerHeight - theadHeight < tableHeight - theadHeight
            : false;
        var scrollbarContainerStyle = {
            display: isScrollable ? "block" : "none",
            boxSizing: "border-box",
            position: "absolute",
            top: theadHeight,
            right: 0,
            bottom: 0,
            backgroundColor: "#E3E5EB",
            width: 8
        };
        scrollbarContainerStyle = customStyle
            ? focused
                ? __assign({}, scrollbarContainerStyle, customStyle.backgroundFocus) : __assign({}, scrollbarContainerStyle, customStyle.background)
            : scrollbarContainerStyle;
        var scrollbarPositionTop = (containerHeight - theadHeight - scrollbarHeight) * percentageScrolled;
        var scrollbarStyle = {
            boxSizing: "border-box",
            position: "absolute",
            top: scrollbarPositionTop,
            right: 0,
            backgroundColor: "#888C97",
            borderRadius: 4,
            width: 8,
            height: scrollbarHeight
        };
        scrollbarStyle = customStyle
            ? focused
                ? __assign({}, scrollbarStyle, customStyle.foregroundFocus) : __assign({}, scrollbarStyle, customStyle.foreground)
            : scrollbarStyle;
        return (createElement("div", { style: scrollbarContainerStyle, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
            createElement("div", { ref: function (ref) { return (_this.scrollbar = ref); }, style: scrollbarStyle })));
    };
    TableVerticalScrollbar.prototype.componentWillUnmount = function () {
        this.scrollbar.removeEventListener("mousedown", this.onMouseDown);
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onMouseUp);
    };
    TableVerticalScrollbar.prototype.calculateDimensions = function () {
        var _a = this.props, container = _a.container, table = _a.table;
        if (!container || !table) {
            return;
        }
        var containerHeight = container.getBoundingClientRect().height;
        var tableHeight = table.getBoundingClientRect().height;
        var theadHeight = table.querySelector("thead").getBoundingClientRect()
            .height;
        var tbodyHeight = tableHeight - theadHeight;
        var visibleContainerHeight = containerHeight - theadHeight;
        var scrollbarHeight = tbodyHeight
            ? Math.pow(visibleContainerHeight, 2) / tbodyHeight
            : 0;
        scrollbarHeight = Math.max(this.minHeight, Math.min(scrollbarHeight, visibleContainerHeight));
        this.setState({
            containerHeight: containerHeight,
            tableHeight: tableHeight,
            theadHeight: theadHeight,
            scrollbarHeight: scrollbarHeight
        });
    };
    return TableVerticalScrollbar;
}(Component));

var TableHorizontalScrollbar = /** @class */ (function (_super) {
    __extends(TableHorizontalScrollbar, _super);
    function TableHorizontalScrollbar(props) {
        var _this = _super.call(this, props) || this;
        _this.minHeight = 15;
        _this.onMouseDown = function (event) {
            event.preventDefault();
            _this.setState({
                isMoving: true,
                previousMoveClientX: event.clientX
            });
        };
        _this.onMouseMove = function (event) {
            event.preventDefault();
            /* tslint:disable:prefer-const */
            var _a = _this.state, percentageScrolled = _a.percentageScrolled, containerWidth = _a.containerWidth, scrollbarWidth = _a.scrollbarWidth, isMoving = _a.isMoving, previousMoveClientX = _a.previousMoveClientX;
            /* tslint:enable:prefer-const */
            if (!isMoving) {
                return;
            }
            var currentMoveClientX = event.clientX;
            var deltaX = currentMoveClientX - previousMoveClientX;
            var scrollbarMoveableDistance = containerWidth - scrollbarWidth;
            percentageScrolled = scrollbarMoveableDistance
                ? (scrollbarMoveableDistance * percentageScrolled + deltaX) /
                    scrollbarMoveableDistance
                : 0;
            percentageScrolled = Math.max(0, Math.min(percentageScrolled, 1));
            previousMoveClientX = currentMoveClientX;
            _this.props.onScroll(percentageScrolled);
            _this.setState({
                percentageScrolled: percentageScrolled,
                previousMoveClientX: previousMoveClientX
            });
        };
        _this.onMouseUp = function (event) {
            event.preventDefault();
            var isMoving = _this.state.isMoving;
            if (!isMoving) {
                return;
            }
            _this.setState({
                isMoving: false,
                previousMoveClientX: 0
            });
        };
        _this.onMouseOver = function () {
            _this.setState({ focused: true });
        };
        _this.onMouseOut = function () {
            _this.setState({ focused: false });
        };
        _this.state = {
            focused: false,
            containerWidth: 0,
            tableWidth: 0,
            scrollbarWidth: 0,
            percentageScrolled: props.scrollTo,
            isMoving: false,
            previousMoveClientX: 0
        };
        return _this;
    }
    TableHorizontalScrollbar.prototype.componentDidMount = function () {
        this.calculateDimensions();
        this.scrollbar.addEventListener("mousedown", this.onMouseDown);
        window.addEventListener("mousemove", this.onMouseMove);
        window.addEventListener("mouseup", this.onMouseUp);
    };
    TableHorizontalScrollbar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.state.percentageScrolled !== nextProps.scrollTo) {
            this.setState({ percentageScrolled: nextProps.scrollTo });
        }
    };
    TableHorizontalScrollbar.prototype.componentDidUpdate = function () {
        var _a = this.props, container = _a.container, table = _a.table;
        var _b = this.state, containerWidth = _b.containerWidth, tableWidth = _b.tableWidth;
        var newContainerWidth = container.getBoundingClientRect().width;
        var newTableWidth = table.getBoundingClientRect().width;
        if (containerWidth !== newContainerWidth || tableWidth !== newTableWidth) {
            this.calculateDimensions();
        }
    };
    TableHorizontalScrollbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, customStyle = _a.customStyle, table = _a.table;
        var _b = this.state, focused = _b.focused, percentageScrolled = _b.percentageScrolled, containerWidth = _b.containerWidth, tableWidth = _b.tableWidth, scrollbarWidth = _b.scrollbarWidth;
        var isScrollable = table ? containerWidth < tableWidth : false;
        var scrollbarContainerStyle = {
            display: isScrollable ? "block" : "none",
            boxSizing: "border-box",
            position: "absolute",
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "#E3E5EB",
            height: 8
        };
        scrollbarContainerStyle = customStyle
            ? focused
                ? __assign({}, scrollbarContainerStyle, customStyle.backgroundFocus) : __assign({}, scrollbarContainerStyle, customStyle.background)
            : scrollbarContainerStyle;
        var scrollbarPositionLeft = (containerWidth - scrollbarWidth) * percentageScrolled;
        var scrollbarStyle = {
            boxSizing: "border-box",
            position: "absolute",
            bottom: 0,
            left: scrollbarPositionLeft,
            backgroundColor: "#888C97",
            borderRadius: 4,
            width: scrollbarWidth,
            height: 8
        };
        scrollbarStyle = customStyle
            ? focused
                ? __assign({}, scrollbarStyle, customStyle.foregroundFocus) : __assign({}, scrollbarStyle, customStyle.foreground)
            : scrollbarStyle;
        return (createElement("div", { style: scrollbarContainerStyle, onMouseOver: this.onMouseOver, onMouseOut: this.onMouseOut },
            createElement("div", { ref: function (ref) { return (_this.scrollbar = ref); }, style: scrollbarStyle })));
    };
    TableHorizontalScrollbar.prototype.componentWillUnmount = function () {
        this.scrollbar.removeEventListener("mousedown", this.onMouseDown);
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onMouseUp);
    };
    TableHorizontalScrollbar.prototype.calculateDimensions = function () {
        var _a = this.props, container = _a.container, table = _a.table;
        if (!container || !table) {
            return;
        }
        var tableWidth = table.getBoundingClientRect().width;
        var containerWidth = container.getBoundingClientRect().width;
        var scrollbarWidth = tableWidth
            ? Math.pow(containerWidth, 2) / tableWidth
            : 0;
        scrollbarWidth = Math.max(this.minHeight, Math.min(scrollbarWidth, containerWidth));
        this.setState({
            containerWidth: containerWidth,
            tableWidth: tableWidth,
            scrollbarWidth: scrollbarWidth
        });
    };
    return TableHorizontalScrollbar;
}(Component));

var FixedHtmlTable$1 = /** @class */ (function (_super) {
    __extends(FixedHtmlTable, _super);
    function FixedHtmlTable(props) {
        var _this = _super.call(this, props) || this;
        _this.headerTableId = 0;
        _this.mainTableId = 1;
        // HTML table header related elements
        _this.headerRelatedElements = ["colgroup", "thead"];
        _this.timeoutId = -1;
        _this.onWindowResize = function () {
            clearTimeout(_this.timeoutId);
            _this.timeoutId = setTimeout(_this.reevaluateDimensions, 16);
        };
        // Make the header table's header cells the same width as the main table's header cells
        _this.refreshHeaders = function () {
            var headerTableHeaderRow = _this.container.querySelector("[data-fht-id=\"" + _this.headerTableId + "\"] thead tr:first-child");
            var mainTableHeaderRow = _this.container.querySelector("[data-fht-id=\"" + _this.mainTableId + "\"] thead tr:first-child");
            if (headerTableHeaderRow && mainTableHeaderRow) {
                var cellsWidth = [];
                // All necessary reads are done first for increased performance
                for (var i = 0; i < mainTableHeaderRow.children.length; i++) {
                    cellsWidth.push(mainTableHeaderRow.children.item(i).getBoundingClientRect().width);
                }
                for (var i = 0; i < mainTableHeaderRow.children.length; i++) {
                    var item = headerTableHeaderRow.children.item(i);
                    item.style.boxSizing = "border-box";
                    item.style.minWidth = cellsWidth[i] + "px";
                }
            }
        };
        // Update dimensions if they have changed
        _this.reevaluateDimensions = function () {
            var _a = _this.state, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, tableWidth = _a.tableWidth, tableHeight = _a.tableHeight;
            var containerBoundingClientRect = _this.container.getBoundingClientRect();
            var tableBoundingClientRect = _this.table.getBoundingClientRect();
            var newContainerWidth = containerBoundingClientRect.width;
            var newContainerHeight = containerBoundingClientRect.height;
            var newTableWidth = tableBoundingClientRect.width;
            var newTableHeight = tableBoundingClientRect.height;
            if (containerWidth !== newContainerWidth ||
                containerHeight !== newContainerHeight ||
                tableWidth !== newTableWidth ||
                tableHeight !== newTableHeight) {
                _this.applyDimensions({
                    containerWidth: newContainerWidth,
                    containerHeight: newContainerHeight,
                    tableWidth: newTableWidth,
                    tableHeight: newTableHeight
                });
            }
        };
        _this.onWheel = function (event) {
            event.preventDefault();
            /* tslint:disable:prefer-const */
            var _a = _this.state, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, tableWidth = _a.tableWidth, tableHeight = _a.tableHeight, tableMarginTop = _a.tableMarginTop, verticalPercentageScrolled = _a.verticalPercentageScrolled, tableMarginLeft = _a.tableMarginLeft, horizontalPercentageScrolled = _a.horizontalPercentageScrolled;
            /* tslint:enable:prefer-const */
            var deltaY = event.deltaY;
            var deltaX = event.deltaX;
            // Adjust if the delta values are specified in lines
            if (event.deltaMode === 1) {
                deltaY *= 10;
                deltaX *= 10;
            }
            // Get vertical properties
            var verticalMaxScrollable = Math.max(0, tableHeight - containerHeight);
            var newTableMarginTop = tableMarginTop + deltaY;
            // Get horizontal properties
            var horizontalMaxScrollable = Math.max(0, tableWidth - containerWidth);
            var newTableMarginLeft = tableMarginLeft + deltaX;
            _this.setWindowScroll(verticalMaxScrollable, newTableMarginTop, horizontalMaxScrollable, newTableMarginLeft);
            // Set vertical properties
            tableMarginTop = Math.max(0, Math.min(newTableMarginTop, verticalMaxScrollable));
            verticalPercentageScrolled = verticalMaxScrollable
                ? tableMarginTop / verticalMaxScrollable
                : 0;
            // Set horizontal properties
            tableMarginLeft = Math.max(0, Math.min(newTableMarginLeft, horizontalMaxScrollable));
            horizontalPercentageScrolled = horizontalMaxScrollable
                ? tableMarginLeft / horizontalMaxScrollable
                : 0;
            _this.setState({
                tableMarginTop: tableMarginTop,
                verticalPercentageScrolled: verticalPercentageScrolled,
                tableMarginLeft: tableMarginLeft,
                horizontalPercentageScrolled: horizontalPercentageScrolled
            });
        };
        _this.onTouchStart = function (event) {
            _this.setState({
                isMoving: true,
                previousSwipeClientX: event.changedTouches[0].clientX,
                previousSwipeClientY: event.changedTouches[0].clientY
            });
        };
        _this.onTouchMove = function (event) {
            event.preventDefault();
            /* tslint:disable:prefer-const */
            var _a = _this.state, containerWidth = _a.containerWidth, containerHeight = _a.containerHeight, tableWidth = _a.tableWidth, tableHeight = _a.tableHeight, tableMarginTop = _a.tableMarginTop, tableMarginLeft = _a.tableMarginLeft, isMoving = _a.isMoving, previousSwipeClientX = _a.previousSwipeClientX, previousSwipeClientY = _a.previousSwipeClientY;
            /* tslint:enable:prefer-const */
            if (!isMoving) {
                return;
            }
            // Get vertical properties
            var verticalMaxScrollable = Math.max(0, tableHeight - containerHeight);
            var currentSwipeClientY = event.changedTouches[0].clientY;
            var deltaY = previousSwipeClientY - currentSwipeClientY;
            var newTableMarginTop = tableMarginTop + deltaY;
            // Get horizontal properties
            var horizontalMaxScrollable = Math.max(0, tableWidth - containerWidth);
            var currentSwipeClientX = event.changedTouches[0].clientX;
            var deltaX = previousSwipeClientX - currentSwipeClientX;
            var newTableMarginLeft = tableMarginLeft + deltaX;
            _this.setWindowScroll(verticalMaxScrollable, newTableMarginTop, horizontalMaxScrollable, newTableMarginLeft);
            // Set vertical properties
            tableMarginTop = Math.max(0, Math.min(newTableMarginTop, verticalMaxScrollable));
            var verticalPercentageScrolled = verticalMaxScrollable
                ? tableMarginTop / verticalMaxScrollable
                : 0;
            previousSwipeClientY = currentSwipeClientY;
            // Set horizontal properties
            tableMarginLeft = Math.max(0, Math.min(newTableMarginLeft, horizontalMaxScrollable));
            var horizontalPercentageScrolled = horizontalMaxScrollable
                ? tableMarginLeft / horizontalMaxScrollable
                : 0;
            previousSwipeClientX = currentSwipeClientX;
            _this.setState({
                tableMarginTop: tableMarginTop,
                verticalPercentageScrolled: verticalPercentageScrolled,
                tableMarginLeft: tableMarginLeft,
                horizontalPercentageScrolled: horizontalPercentageScrolled,
                previousSwipeClientY: previousSwipeClientY,
                previousSwipeClientX: previousSwipeClientX
            });
        };
        _this.onTouchEnd = function (event) {
            _this.setState({
                isMoving: false,
                previousSwipeClientX: 0,
                previousSwipeClientY: 0
            });
        };
        _this.onVerticalScroll = function (scrollTo) {
            var _a = _this.state, containerHeight = _a.containerHeight, tableHeight = _a.tableHeight;
            var maxScrollable = tableHeight - containerHeight;
            var tableMarginTop = Math.max(0, Math.min(scrollTo * maxScrollable, maxScrollable));
            _this.setState({
                tableMarginTop: tableMarginTop,
                verticalPercentageScrolled: scrollTo
            });
        };
        _this.onHorizontalScroll = function (scrollTo) {
            var _a = _this.state, containerWidth = _a.containerWidth, tableWidth = _a.tableWidth;
            var maxScrollable = tableWidth - containerWidth;
            var tableMarginLeft = Math.max(0, Math.min(scrollTo * maxScrollable, maxScrollable));
            _this.setState({
                tableMarginLeft: tableMarginLeft,
                horizontalPercentageScrolled: scrollTo
            });
        };
        _this.state = {
            containerWidth: 0,
            containerHeight: 0,
            tableWidth: 0,
            tableHeight: 0,
            tableMarginTop: 0,
            verticalPercentageScrolled: 0,
            tableMarginLeft: 0,
            horizontalPercentageScrolled: 0,
            isMoving: false,
            previousSwipeClientX: 0,
            previousSwipeClientY: 0
        };
        return _this;
    }
    FixedHtmlTable.prototype.componentDidMount = function () {
        this.table = this.container.querySelector("[data-fht-id=\"" + this.mainTableId + "\"]");
        this.tbody = this.table.querySelector("tbody");
        this.tbody.addEventListener("wheel", this.onWheel);
        this.tbody.addEventListener("touchstart", this.onTouchStart);
        this.tbody.addEventListener("touchmove", this.onTouchMove);
        this.tbody.addEventListener("touchend", this.onTouchEnd);
        this.tbody.addEventListener("touchcancel", this.onTouchEnd);
        window.addEventListener("resize", this.onWindowResize);
        var containerBoundingClientRect = this.container.getBoundingClientRect();
        var tableBoundingClientRect = this.table.getBoundingClientRect();
        this.applyDimensions({
            containerWidth: containerBoundingClientRect.width,
            containerHeight: containerBoundingClientRect.height,
            tableWidth: tableBoundingClientRect.width,
            tableHeight: tableBoundingClientRect.height
        });
    };
    FixedHtmlTable.prototype.componentDidUpdate = function () {
        this.refreshHeaders();
        this.reevaluateDimensions();
    };
    FixedHtmlTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, scrollbarStyle = _a.scrollbarStyle, width = _a.width, height = _a.height;
        var _b = this.state, tableMarginTop = _b.tableMarginTop, verticalPercentageScrolled = _b.verticalPercentageScrolled, tableMarginLeft = _b.tableMarginLeft, horizontalPercentageScrolled = _b.horizontalPercentageScrolled;
        var containerStyle = {
            boxSizing: "border-box",
            position: "relative",
            display: "inline-block",
            overflow: "hidden",
            width: width,
            height: height
        };
        var htmlTable = Children.only(children);
        var htmlTableChildren = Children.toArray(htmlTable.props.children);
        // Extract out table header related html elements
        var headerRelatedChildren = htmlTableChildren.filter(function (child) {
            return (typeof child.type === "string" &&
                _this.headerRelatedElements.indexOf(child.type) > -1);
        });
        // Set header table props
        var headerTableProps = __assign({}, htmlTable.props);
        headerTableProps["data-fht-id"] = this.headerTableId;
        var headerTableStyle = {
            borderSpacing: 0,
            position: "absolute",
            top: 0,
            left: -tableMarginLeft,
            zIndex: 1
        };
        headerTableProps.style = headerTableProps.style
            ? __assign({}, headerTableProps.style, headerTableStyle) : headerTableStyle;
        // Set main table props
        var mainTableProps = __assign({}, htmlTable.props);
        mainTableProps["data-fht-id"] = this.mainTableId;
        var mainTableStyle = {
            borderSpacing: 0,
            marginTop: -tableMarginTop,
            marginLeft: -tableMarginLeft
        };
        mainTableProps.style = mainTableProps.style
            ? __assign({}, mainTableProps.style, mainTableStyle) : mainTableStyle;
        return (createElement("div", { ref: function (ref) { return (_this.container = ref); }, style: containerStyle },
            cloneElement(htmlTable, headerTableProps, headerRelatedChildren),
            cloneElement(htmlTable, mainTableProps),
            createElement(TableVerticalScrollbar, { customStyle: scrollbarStyle, container: this.container, table: this.table, scrollTo: verticalPercentageScrolled, onScroll: this.onVerticalScroll }),
            createElement(TableHorizontalScrollbar, { customStyle: scrollbarStyle, container: this.container, table: this.table, scrollTo: horizontalPercentageScrolled, onScroll: this.onHorizontalScroll })));
    };
    FixedHtmlTable.prototype.componentWillUnmount = function () {
        this.tbody.removeEventListener("wheel", this.onWheel);
        this.tbody.removeEventListener("touchstart", this.onTouchStart);
        this.tbody.removeEventListener("touchmove", this.onTouchMove);
        this.tbody.removeEventListener("touchend", this.onTouchEnd);
        this.tbody.removeEventListener("touchcancel", this.onTouchEnd);
        window.removeEventListener("resize", this.onWindowResize);
    };
    FixedHtmlTable.prototype.applyDimensions = function (dimensions) {
        var _a = this.state, tableMarginTop = _a.tableMarginTop, verticalPercentageScrolled = _a.verticalPercentageScrolled, tableMarginLeft = _a.tableMarginLeft, horizontalPercentageScrolled = _a.horizontalPercentageScrolled;
        var verticalMaxScrollable = dimensions.tableHeight - dimensions.containerHeight;
        tableMarginTop = Math.max(0, Math.min(tableMarginTop, verticalMaxScrollable));
        verticalPercentageScrolled = verticalMaxScrollable
            ? tableMarginTop / verticalMaxScrollable
            : 0;
        var horizontalMaxScrollable = dimensions.tableWidth - dimensions.containerWidth;
        tableMarginLeft = Math.max(0, Math.min(tableMarginLeft, horizontalMaxScrollable));
        horizontalPercentageScrolled = horizontalMaxScrollable
            ? tableMarginLeft / horizontalMaxScrollable
            : 0;
        this.setState({
            containerWidth: dimensions.containerWidth,
            containerHeight: dimensions.containerHeight,
            tableWidth: dimensions.tableWidth,
            tableHeight: dimensions.tableHeight,
            tableMarginTop: tableMarginTop,
            verticalPercentageScrolled: verticalPercentageScrolled,
            tableMarginLeft: tableMarginLeft,
            horizontalPercentageScrolled: horizontalPercentageScrolled
        });
    };
    // If scrolling within the table hits any boundary, propagate it onto the window object
    FixedHtmlTable.prototype.setWindowScroll = function (verticalMaxScrollable, newTableMarginTop, horizontalMaxScrollable, newTableMarginLeft) {
        var scrollByX = 0;
        var scrollByY = 0;
        if (newTableMarginTop < 0) {
            scrollByY = newTableMarginTop;
        }
        else if (newTableMarginTop > verticalMaxScrollable) {
            scrollByY = newTableMarginTop - verticalMaxScrollable;
        }
        if (newTableMarginLeft < 0) {
            scrollByX = newTableMarginLeft;
        }
        else if (newTableMarginLeft > horizontalMaxScrollable) {
            scrollByX = newTableMarginLeft - horizontalMaxScrollable;
        }
        window.scrollBy(scrollByX, scrollByY);
    };
    return FixedHtmlTable;
}(Component));

export default FixedHtmlTable$1;



//////////////////
// WEBPACK FOOTER
// ./node_modules/fixed-html-table/es/fixed-html-table.js
// module id = 801
// module chunks = 0